function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_3343_7867)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.0009 0.550049C4.92475 0.550049 0 5.4748 0 11.551C0 14.1955 0.934363 16.6249 2.48975 18.5219L0.294466 21.5723C0.0132132 21.9649 0.332218 22.5047 0.811669 22.4462L6.7897 21.7176C8.08837 22.2556 9.50785 22.5519 11.0009 22.5519C17.0752 22.5519 22.0019 17.6272 22.0019 11.551C22 5.4748 17.0752 0.550049 11.0009 0.550049ZM16.8299 11.8473C16.3032 12.8402 15.5954 13.7029 14.8233 14.5126C13.6719 15.7226 12.3883 16.7834 11.0538 17.782C11.0349 17.7971 11.016 17.8084 10.9858 17.8273C10.6253 17.5347 10.2667 17.2459 9.90991 16.9514C8.85474 16.0775 7.82411 15.1752 6.89163 14.171C6.12527 13.3461 5.42874 12.474 4.94929 11.4453C4.68314 10.879 4.50571 10.2882 4.48305 9.6615C4.4302 8.26656 5.13616 6.47901 7.16722 6.08638C8.39039 5.85232 9.50785 6.08261 10.3894 7.03207C10.6196 7.28124 10.8027 7.57759 10.9953 7.83808C11.1727 7.59269 11.3464 7.31144 11.5597 7.06605C12.2354 6.2978 13.0924 5.94481 14.1155 6.00711C15.0027 6.06185 15.8087 6.328 16.475 6.93581C17.0979 7.50397 17.4207 8.22504 17.5037 9.05936C17.6019 10.0654 17.2942 10.979 16.8299 11.8492V11.8473Z",
  fill: "white"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3343_7867"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  fill: "white",
  transform: "translate(0 0.550049)"
})));
function SvgBrandEquity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandEquity);
export default __webpack_public_path__ + "static/media/BrandEquity.4e4d5513a4d97bab98fa5556c8e2312b.svg";
export { ForwardRef as ReactComponent };